import { stringIncludesInsensitiveAccents } from '../../utils/normalizeForSearch';

/**
 * Add IDs to importUrls items using url as unique identifier
 * @param {Array<ApiManagerTableImportUrls>} items - The items to add IDs to
 * @returns {Array<TableImportUrlsWithId>} Items with IDs
 */
export const addIdsToImportUrls = (items) => items.map((item, index) => ({
  ...item,
  id: item.url || `import-${index}`,
}));

/**
 * Filter importUrls by search value (searches in lib only)
 * @param {Array<TableImportUrlsWithId>} items - The items to filter
 * @param {string} searchValue - The search value
 * @returns {Array<TableImportUrlsWithId>} Filtered items
 */
export const filterImportUrlsBySearch = (items, searchValue) => {
  if (!searchValue) return items;

  return items.filter((item) => stringIncludesInsensitiveAccents(item.lib, searchValue));
};
